@import 'styles/variables';
@import 'styles/mixins';

.root {
  margin: 0;
  color: var(--neutral-90, #2b2f38);
  font-family: Roboto Flex;
  font-size: 26px;
  font-style: normal;
  font-weight: 900;
  line-height: 110%; /* 28.6px */
  letter-spacing: -0.26px;
  text-transform: uppercase;
}
